export function replaceNode(oldNode, ...newNodes) {
  const container = oldNode.parentNode
  newNodes.forEach((node) => {
    container.insertBefore(node, oldNode)
  })
  container.removeChild(oldNode)
}
